interface Comment {
  author: string;
  content: string;
  is_resolved: boolean;
  created_at: string;
}

export interface CommentThread {
  thread_id: string;
  is_resolved: boolean;
  comments: Comment[];
}

export interface Suggestion {
  id: string;
  type: string;
  author: string;
  created_at: string;
}

interface ConversionResult {
  html: string;
  document_margins: {
    top: number;
    right: number;
    bottom: number;
    left: number;
  };
  document_size: {
    width: number;
    height: number;
  };
  comment_threads: CommentThread[];
  suggestions: Suggestion[];
}

export async function convertWordDoc(
  file: File,
  token: string,
  userID: string,
): Promise<{
  html: string;
  comment_threads?: CommentThread[];
  suggestions?: Suggestion[];
}> {
  const conversionConfig = {
    default_styles: true,
    collaboration_features: {
      user_id: userID,
      comments: true,
      track_changes: true,
    },
  };

  const formData = new FormData();
  formData.append("config", JSON.stringify(conversionConfig));
  formData.append("file", file, file.name);

  const response = await fetch(
    "https://docx-converter.cke-cs.com/v2/convert/docx-html",
    {
      method: "POST",
      headers: {
        Authorization: `${token}`,
      },
      body: formData,
    },
  );

  if (!response.ok) {
    throw new Error(`Conversion failed: ${response.statusText}`);
  }

  const result = (await response.json()) as ConversionResult;

  return result;
}
